<template>
  <rest-list-column
    :prop="prop"
    :title="title"
    :route="route"
    :width="width"
    :min-width="minWidth"
    :filter-options="filterOptions"
    :filter-options-order="order"
    :formatter="formatter || defaultFormat"
    :sortable="sortable"
    :filterable="filterable"
    :searchable="selectSearch"
    :allow-multiple="allowMultiple"
    :clearable="clearable"
    :editable="editable"
    :number="number"
    :fixed="fixed"
    :show-overflow-tooltip="showOverflowTooltip"
  >
    <template slot="input-edit" slot-scope="{ model }">
      <slot name="input-edit" :model="model">
        <enum-select
          v-model="model[prop]"
          :options="filterOptions"
          :order="order"
          :number="number"
          :filterable="selectSearch"
          :translate="translate"
          :data-qa="`edit-${prop.replace('_', '-')}-dropdown`"
        />
      </slot>
    </template>
    <template v-slot:default="scope">
      <slot name="default" v-bind="scope" />
    </template>
  </rest-list-column>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { getEnumTranslations } from '@/core/helpers'
import EnumSelect from '@/common/components/form/EnumSelect'

export default {
  name: 'RestListColumnEnum',

  components: { EnumSelect, RestListColumn },

  props: {
    prop: {
      type: String,
      required: true
    },

    enum: {
      type: Object,
      required: true
    },

    order: {
      type: Array,
      required: false
    },

    title: {
      type: String,
      required: true
    },

    route: {
      type: Function,
      required: false
    },

    width: {
      type: Number,
      required: false
    },

    minWidth: {
      type: Number,
      required: false
    },

    formatter: {
      type: Function,
      required: false
    },

    sortable: {
      required: false
    },

    translate: {
      required: false,
      default: true
    },

    allowMultiple: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: true
    },

    editable: {
      type: Boolean,
      required: false,
      default: false
    },

    number: {
      type: Boolean,
      default: false
    },

    fixed: {
      type: [Boolean, String],
      required: false,
      default: false
    },

    selectSearch: {
      type: Boolean,
      required: false,
      default: false
    },

    showOverflowTooltip: {
      type: Boolean,
      required: false,
      default: false
    },

    filterable: {
      type: Boolean,
      default: true
    },

    dataQa: {
      type: String,
      required: false
    }
  },

  computed: {
    filterOptions() {
      if (this.translate) {
        return getEnumTranslations(this.enum)
      }

      return this.enum
    }
  },

  methods: {
    defaultFormat(value) {
      if (value || value === 0) {
        if (this.enum[value]) {
          if (this.translate) {
            return this.$t(this.enum[value])
          } else {
            return this.enum[value]
          }
        } else {
          return value
        }
      } else {
        return '-'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnEnum.vue